import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_PATHS } from "../../legal/legalPaths";
import "./legal-components.css";

export default function TreydoraGatewayLegalStrip() {
  return (
    <nav className="td-gateway-legal-strip" aria-label="Legal shortcuts">
      <span className="td-gateway-legal-strip__label">Rights archive</span>
      <Link to={LEGAL_PATHS.center}>Legal Center</Link>
      <Link to={LEGAL_PATHS.nftComicMerchLicense}>Comic license</Link>
      <Link to={LEGAL_PATHS.vrRealEstateTerms}>Virtual property</Link>
      <Link to={LEGAL_PATHS.marketplaceSellerTerms}>Seller terms</Link>
    </nav>
  );
}
